module.exports = __webpack_public_path__ + "static/media/img-2.7c23b226.svg";